import './About.css'
function About() {
  return (
    <div className="about">
      <div className="left">
        <h1>Who I Am</h1>
        <h3>
          A passionate Frontend Developer crafting modern and user-centric web
          designs.
        </h3>
        <img
          src="https://images.unsplash.com/photo-1651684195895-38708dc94cfa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx3ZWIlMjBkZXZlbG9wZXIlMjB3b3Jrc3BhY2UlMjBkZXNrfGVufDF8fHx8MTc3MDAzOTI5Nnww&ixlib=rb-4.1.0&q=80&w=1080"
          alt=""
        />
      </div>
      <div className="right">
        <h1>
          Frontend Developer | HTML, CSS, JavaScript, React | Landing Pages & UI
        </h1>
        <h3>
          I help startups and businesses build clean, responsive, and
          high-performance frontend interfaces using HTML, CSS, JavaScript, and
          React. Whether you need a modern landing page, a responsive UI, or
          fixes for layout and frontend bugs — I can help you deliver a smooth
          and user-friendly experience across all devices.
        </h3>
        <h4>
          🔹 Frontend Skills & Expertise
          <br></br> ✔ HTML5, CSS3, JavaScript (ES6+)<br></br>
          ✔React.js – Component-based UI & basic hooks
          <br></br> ✔ Responsive Design –Mobile-first & cross-browser
          compatibility
          <br></br>✔ UI Styling – Tailwind CSS, Bootstrap
          <br></br>✔ Fixing UI bugs & layout issues<br></br> ✔ Figma / XD / PSD
          to HTML or React<br></br> ✔ Performance optimization & clean code
        </h4>
      </div>
    </div>
  );
}

export default About
